const TPS_REQUEST_TICKET_TITLE = "[TPS] Request to update TPS for ";
const TPS_REQUEST_TICKET_SEVERITY = "FIVE";

/**
 * Get URL for a prefilled ticket template.
 * @param title
 * @param description
 * @param severity
 * @param category
 * @param type
 * @param item
 * @param group
 */
function ticketCutURL({title, description, severity, category, type, item}) {
    return `https://t.corp.amazon.com/create/options?`
        + `title=${encodeURIComponent(title)}`
        + `&description=${encodeURIComponent(description)}`
        + `&severity=${encodeURIComponent(severity)}`
        + `&category=${encodeURIComponent(category)}`
        + `&type=${encodeURIComponent(type)}`
        + `&item=${encodeURIComponent(item)}`
        + `&tags=DependencyAnalyzer`;
}

/**
 * Get Ticket template URL for TPS change request.
 * @param serviceName
 * @param apis
 * @param cti
 * @returns {string}
 */
export function getTPSRequestTicketURL(serviceName, region,
                                       apis = [{currentTps: 0, requiredTps: 0, serviceName: "", graphImageLink: "", link: ""}],
                                       cti = {category: "", type: "", item: ""}) {
    const title = TPS_REQUEST_TICKET_TITLE + serviceName + ` (${region})`;
    let description = `Requesting to update TPS required of ${serviceName} for the following APIs in ${region} region:\n\n`;
    apis.forEach(api => {
        description = description +
            `API Name: ${api.serviceName}\n` +
            `Current TPS: ${api.currentTps}\n` +
            `Required TPS: ${api.requiredTps}\n` +
            `IGraph: ${api.graphImageLink}\n${api.link}\n\n`
    })
    description = description + `Recommended TPS calculated using Dependency Analyzer`;
    const severity = TPS_REQUEST_TICKET_SEVERITY;
    return ticketCutURL({...cti, title, description, severity});
}


// WEBPACK FOOTER //
// ./src/components/util/TicketUtils.js